import { GeoJsonPolygon } from './geojson.model';

export interface GeoAssets {
  id: string;
  name: string;
  type: string;
  gcp?: GroundControlPoint;
  noFlyZone?: NoFlyZone;
}

export interface GroundControlPoint {
  id: string;
  name: string;
  description: string;
  location: string;
  type: string;
  point: GeoPoint;
  height?: Height;
  attachmentIds: string[];
}

export interface GeoPoint {
  type: string;
  bbox: [number];
  coordinates: [number, number]; // [longitude, latitude]
}

export interface Height {
  value?: number;
  mode?: HeightMode;
}

export enum HeightMode {
  MSL = 'MSL',
  AGL = 'AGL',
  GND = 'GND',
  UNL = 'UNL',
}

export enum InputMode {
  EDIT = 'EDIT',
  ADD = 'ADD',
}

export interface MapFilterSettings {
  showGcpAssets: boolean;
  showNoFlightZones: boolean;
}

export interface NoFlyZone {
  id: string;
  name: string;
  type: string;
  description: string;
  area: GeoJsonPolygon;
  lowerAltitude: Height;
  upperAltitude: Height;
}

export interface GcpAsset {
  id: string;
  originalFileName: string;
  referenceId: string;
  url: string;
  expireAt: string;
}
